var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"object-info__actions"},_vm._l((_vm.filteredActions),function(action){return _c('r-button',{key:action.title,attrs:{"type":action.type,"icon":action.icon},on:{"click":function($event){return _vm.callFunction(action.title)}}},[_vm._v(" "+_vm._s(_vm.$t(action.title))+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }